import type { Translate } from "@similarweb/i18n-provider";
import { TextCell, type ColumnsType } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { TeamUser } from "../../types/teams.types";
import { getAccountUserColumnsMap } from "../TeamAccountUsersTable/accountUserColumns";

export type TeamUserTableRow = TeamUser & { key: number };

export const getTeamMembersColumns = (translate: Translate, currentUserId?: number): ColumnsType<TeamUserTableRow> => {
    const { name, email, jobTitle, country } = getAccountUserColumnsMap<TeamUserTableRow>(translate);

    return [
        {
            ...name,
            render: (_value, record) => (
                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    <TextCell>{record.name ?? ""}</TextCell>
                    {currentUserId !== undefined && record.userId === currentUserId ? (
                        <Badge
                            bgColor={colorsPalettes.midnight["300"]}
                            color={colorsPalettes.carbon["0"]}
                            type="custom"
                        >
                            {translate("si.management.teams.detail.badge.me")}
                        </Badge>
                    ) : null}
                </Flex>
            ),
        },
        email,
        jobTitle,
        {
            ...country,
            width: undefined,
        },
    ];
};
